<template>
  <div class="ethicc-mobile-topbar show-mobile">
    <img :src="logo" alt="ETHICC" class="mobile-topbar__logo" />
    <div class="mobile-topbar__actions">
      <button class="mobile-topbar__button" @click="$emit('user-menu-click')">
        <Icon name="user" :size="18" />
        <span class="mobile-topbar__username">{{ displayName }}</span>
      </button>
      <button class="mobile-topbar__button main-menu-mobile-button" @click="$emit('main-menu-click')">
        <Icon name="menu" :size="16" />
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import Icon from '@/components/icons/Icon.vue'
import logo from '@/assets/ethicc_logo.svg?url'
import { computed } from 'vue'
import { useAuthStore } from '@/stores/auth'

const authStore = useAuthStore()
const displayName = computed(() => {
  const dbName = authStore.userFullName
  if (dbName) return dbName
  const u = authStore.user as any
  const meta = u?.user_metadata || {}
  return (
    meta.full_name ||
    meta.display_name ||
    meta.name ||
    (meta.first_name && meta.last_name ? `${meta.first_name} ${meta.last_name}` : undefined) ||
    u?.email ||
    'Utilisateur'
  )
})

defineEmits<{
  (e: 'user-menu-click'): void
  (e: 'main-menu-click'): void
}>()
</script>

<style scoped>
.ethicc-mobile-topbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: var(--layout-sidebar-bg);
  position: absolute;
  top: 0;
  z-index: 20;
  width: 100%;
  padding: 0 16px;
  height: 48px;
}

.mobile-topbar__logo {
  width: 20px;
  filter: brightness(0) invert(1);
}

.mobile-topbar__actions {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.mobile-topbar__button {
  display: flex;
  align-items: center;
  gap: 0.8rem;
  padding: 0.4rem;
  background: none;
  border: none;
  border-radius: 0.5rem;
  cursor: pointer;
}

.mobile-topbar__button :deep(svg) {
  color: white;
}

.mobile-topbar__button:active {
  background: rgba(255, 255, 255, 0.1);
}

.mobile-topbar__username {
  font-size: 0.8rem;
  font-family: Rubik, sans-serif;
  font-weight: 500;
  color: white;
}

.main-menu-mobile-button {
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.main-menu-mobile-button :deep(svg) {
  color: white;
}

.main-menu-mobile-button:active {
  background: rgba(255, 255, 255, 0.1);
}

@media screen and (min-width: 480px) {
  .mobile-topbar__username {
    display: inline;
  }
}
</style>
